module.exports = __webpack_public_path__ + "img/plata_2022_v2.46b590f4.png";